/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProfileData
 */
export interface UserProfileData {
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileData
     */
    timezone: string;
}

/**
 * Check if a given object implements the UserProfileData interface.
 */
export function instanceOfUserProfileData(value: object): value is UserProfileData {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    return true;
}

export function UserProfileDataFromJSON(json: any): UserProfileData {
    return UserProfileDataFromJSONTyped(json, false);
}

export function UserProfileDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileData {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'language': json['language'],
        'timezone': json['timezone'],
    };
}

  export function UserProfileDataToJSON(json: any): UserProfileData {
      return UserProfileDataToJSONTyped(json, false);
  }

  export function UserProfileDataToJSONTyped(value?: UserProfileData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'language': value['language'],
        'timezone': value['timezone'],
    };
}

